// Envio da apolice pelo WhatsApp Web (aba Anexos da Proposta/Apolice): o link de conversa nao
// aceita anexo, entao o botao abre a conversa do cliente com o texto pronto e baixa o PDF pro
// corretor arrastar pra dentro dela. Texto = versao WhatsApp do e-mail "Envio da Apólice".

// Celular do cadastro -> formato internacional so com digitos (55 + DDD + numero).
export const normalizarTelefoneWhatsApp = (numero) => {
  let d = String(numero || '').replace(/\D/g, '').replace(/^0+/, '')
  if (d.length === 10 || d.length === 11) d = '55' + d
  return d
}

export const linkWhatsAppWeb = (telefone, texto) =>
  `https://web.whatsapp.com/send?phone=${normalizarTelefoneWhatsApp(telefone)}&text=${encodeURIComponent(texto)}`

// Bloco "Fale com a gente" da mensagem padrao — reaproveitado nos modelos de e-mail que tem esse
// trecho (ver ajustarModeloWhatsApp), pra ficar igual ao padrao.
const BLOCO_FALE_CONOSCO = [
  '*FALE COM A GENTE*',
  'Se preferir falar conosco, estes são os nossos contatos:',
  '📞 *Mari:* (41) 98471-3000',
  '📞 *Eder:* (41) 98473-3000',
  '📞 *Hailton:* (41) 99703-0081',
  '🕗 Para Assistência 24h ou Sinistros, estamos de plantão SOMENTE POR LIGAÇÃO. Se for urgente, ligue imediatamente. Não envie WhatsApp.',
]

export const montarMensagemApoliceWhatsApp = (d) => {
  const link = (d.link_assistencia || '').trim()
  const central = (d.central_segurado || '').trim()
  return [
    `Olá, *${d.primeiro_nome || ''}*! Tudo certo?`,
    '',
    // Concorda com o tipo do documento, igual a tag {{Sua|Seu}} dos modelos (Endosso = masculino)
    d.tipo_documento === 'Endosso'
      ? `Seu *${d.tipo_documento} ${d.ramo || ''} já está emitido* e estamos enviando aqui a sua via digital.`
      : `Sua *${d.tipo_documento || 'Apólice'} ${d.ramo || ''} já está emitida* e estamos enviando aqui a sua via digital.`,
    '',
    'Lembrando que as seguradoras não enviam mais o kit físico pelos Correios. Por isso, você pode *salvar* ou *imprimir* esta versão sempre que precisar.',
    '',
    '🚨 *ASSISTÊNCIA 24H*',
    `Para acionar a *Assistência 24h da ${d.seguradora || ''}*, use um dos canais abaixo:`,
    link ? `💬 *WhatsApp direto da seguradora:* ${link}` : null,
    central ? `📞 *Central de atendimento:* ${central}` : null,
    '',
    ...BLOCO_FALE_CONOSCO,
    '',
    `⚠️ *Atenção importante:* confira seus dados ${d.tipo_documento === 'Endosso' ? 'no Endosso' : `na ${d.tipo_documento || 'Apólice'}`}. Caso encontre alguma divergência, ou se houver qualquer alteração durante a vigência (como mudança de endereço, CEP, uso do veículo, condutor principal etc.), fale com a gente. É dever do segurado manter as informações sempre atualizadas e, assim, garantir que as suas coberturas não sejam afetadas.`,
    '',
    'Qualquer dúvida, estamos por aqui para ajudar sempre que precisar!',
    'Agradecemos a confiança!',
    '',
    '*EMSeg Tiepolo Corretora de Seguros Ltda*',
  ].filter(l => l !== null).join('\n')
}

// Modelo de e-mail (Cadastro > Modelos de E-mail, HTML) -> texto de WhatsApp: negrito vira *x*,
// italico _x_, link com texto proprio vira "texto: url" (tel: fica so o numero), blocos viram
// quebra de linha. Imagens, <head> e o texto oculto de pre-visualizacao do e-mail sao descartados.
// Modelo antigo em texto puro (sem tag nenhuma) passa direto.
const BLOCOS = new Set(['P', 'DIV', 'TR', 'TABLE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'UL', 'OL', 'BLOCKQUOTE'])
const IGNORAR = new Set(['HEAD', 'TITLE', 'STYLE', 'SCRIPT', 'IMG'])

const envolver = (texto, marca) => {
  const m = texto.match(/^(\s*)([\s\S]*?)(\s*)$/)
  return m[2] ? `${m[1]}${marca}${m[2]}${marca}${m[3]}` : texto
}

const converterNo = (no) => {
  if (no.nodeType === 3) return no.nodeValue.replace(/\s+/g, ' ')
  if (no.nodeType !== 1 || IGNORAR.has(no.tagName)) return ''
  if (/display\s*:\s*none/i.test(no.getAttribute('style') || '')) return ''
  const interno = Array.from(no.childNodes).map(converterNo).join('')
  switch (no.tagName) {
    case 'BR': return '\n'
    case 'B': case 'STRONG': return envolver(interno, '*')
    case 'I': case 'EM': return envolver(interno, '_')
    case 'A': {
      const href = (no.getAttribute('href') || '').trim()
      const texto = interno.trim()
      if (!/^https?:/i.test(href) || !texto || texto === href) return interno || href
      return `${texto}: ${href}`
    }
    case 'TD': case 'TH': return interno + ' '
    default: return BLOCOS.has(no.tagName) ? `\n${interno}\n` : interno
  }
}

export const htmlParaTextoWhatsApp = (html) => {
  if (!/<[a-z][\s\S]*>/i.test(html || '')) return (html || '').trim()
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return converterNo(doc.body)
    .split('\n').map(l => l.replace(/[ \t\u00a0]+/g, ' ').trim()).join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

// Ajustes do texto do modelo de e-mail pro WhatsApp (pedido do usuario 13/10): tira o cabecalho do
// e-mail (tudo antes do "Olá"), junta os contatos (linhas com 📞) sem linha em branco entre eles,
// "Não envie whatsapp." na mesma linha do "imediatamente.", tira o titulo "Documento em anexo",
// "enviando em anexo" -> "enviando abaixo" e tira as frases "Acessar minha proposta:" e "Acessar proposta de endosso:".
export const ajustarModeloWhatsApp = (texto) => {
  let t = texto || ''
  const ola = t.search(/^Olá/m)
  if (ola > 0) t = t.slice(ola)
  return t
    .replace(/(^📞[^\n]*)\n\n(?=📞)/gm, '$1\n')
    .replace(/(^📞[^\n]*)\n\n(?=📞)/gm, '$1\n')
    .replace(/imediatamente\.\s*\n\s*Não envie whatsapp\./gi, m => m.replace(/\s*\n\s*/, ' '))
    // Trecho "Fale com a gente ... Não envie whatsapp." (ex.: Envio de Apólice (Genérico)) = bloco do padrao
    .replace(/^Fale com a gente[\s\S]*?Não envie whatsapp\./im, BLOCO_FALE_CONOSCO.join('\n'))
    // Sem linha em branco entre o titulo "Fale com a gente" e o 1o contato (modelos de cancelamento)
    .replace(/^Fale com a gente\n\n(?=📞)/gm, 'Fale com a gente\n')
    // No WhatsApp nao tem botao: tira "Se o botão não abrir..." e o link repetido da linha seguinte
    .replace(/^Se o botão não abrir[^\n]*\n[^\n]*\n*/gm, '')
    // Sem linha em branco embaixo de "1. Revise as informações" / "2. Assine digitalmente" (propostas)
    .replace(/^(\d\. (?:Revise as informações|Assine digitalmente))\n\n/gm, '$1\n')
    .replace(/^Documento em anexo\s*\n+/gm, '')
    .replace(/Estamos enviando em anexo/g, 'Estamos enviando abaixo')
    .replace(/Acessar (minha proposta|proposta de endosso):\s*/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
